<template>
  <button :class="[color, size]" v-on="$listeners"><slot></slot></button>
</template>
<script>
export default {
  name: 'RoundedButton',

  props: {
    color: {
      default: ''
    },

    size: {
      default: 'medium'
    }
  }
}
</script>
<style lang="scss" scoped>
button {
  display: block;
  background-color: #444;
  color: #FFF;
  text-transform: uppercase;
  font-size: 18px;
  text-align: center;
  border-radius: 50px;
  padding: 8px;
  text-decoration: none;
  border: 2px solid #444;
  transition: 0.3s;
  outline: none;
  min-width: 180px;

  &:hover {
    background-color: #666;
    border: 2px solid #666;
    color: #FFF;
    text-decoration: none;
  }

  &.primary {
    background-color: $primary;
    border: 2px solid $primary;
  }

  &.primary:hover, &.primary:active {
    background-color: #FFF;
    border: 2px solid $primary;
    color: $primary;
  }

  &.outline {
    background-color: #FFF;
    border: 2px solid $primary;
    color: $primary;
  }

  &.outline:hover, &.outline:active {
    background-color: $primary;
    border: 2px solid $primary;
    color: #FFF;
  }

  &.small {
    padding: 4px;
    min-width: 120px;
    height: 40px;
  }

  &.large {
    padding: 13px;
    min-width: 240px;
  }
}
</style>
